import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { LogOut } from '@/components/icons';

interface Props {
  /** Called after sign-out completes (e.g. to close a drawer). */
  onSignedOut?: () => void;
}

/**
 * Minimal account block pinned to the bottom of the nav:
 * the signed-in email + a small "Sign out" link with a power icon.
 * No avatar, no border-framed button, no divider above.
 */
export default function AccountFooter({ onSignedOut }: Props) {
  const { user, logOut } = useAuth();
  const nav = useNavigate();

  if (!user) return null;

  async function signOut() {
    onSignedOut?.();
    await logOut();
    nav('/login', { replace: true });
  }

  return (
    <div className="px-3 pb-3 pt-2">
      <div className="text-[10px] uppercase tracking-wider font-semibold text-fg-subtle">
        Signed in as
      </div>
      <div className="text-[12px] text-fg truncate mt-0.5">{user.email}</div>
      <button
        type="button"
        onClick={signOut}
        className="mt-2 inline-flex items-center gap-1.5 text-[12px] font-medium text-fg-muted hover:text-fg transition-colors"
      >
        <LogOut size={13} />
        Sign out
      </button>
    </div>
  );
}
